import { useTranslation } from 'react-i18next'
import { useGetCalendarSettings } from '@/api/endpoints/index.ts'
import type { ModifyCalendarSettingsJSON } from '@/api/model/modifyCalendarSettingsJSON'
import { calcRemaining } from '@/statisticsview/vacancy/ManualTab/vacationBalanceUtils.js'

export function BalancesTable({ data }) {
	const { t } = useTranslation()
	const { data: calendarSettings } = useGetCalendarSettings<ModifyCalendarSettingsJSON>()
	const saturdaysCalculatedAsHoliday = calendarSettings?.saturdaysCalculatedAsHoliday !== false

	return (
		<div style={styles.container}>
			<table style={styles.table}>
				<thead>
					<tr>
						<th style={styles.th}>{t('VacationYearDays', 'Lomavuoden lomapäivät')}</th>
						<th style={styles.th}>
							{t('Remaining', 'Jäljellä')} / {t('Earned', 'Ansaitut')}
						</th>
						{saturdaysCalculatedAsHoliday && <th style={styles.th}>{t('Saturdays', 'Lauantait')}</th>}
					</tr>
				</thead>

				<tbody>
					{data.map((item) => {
						// usedVacationDays from backend = businessDays + saturdaysUsed (CalendarDurationsUtils)
						const total = item.vacationAllowanceDays + item.vacationExtraDays
						const remaining = calcRemaining(
							item.vacationAllowanceDays,
							item.vacationExtraDays,
							item.usedVacationDays,
							item.saturdaysUsed,
							saturdaysCalculatedAsHoliday,
						)
						const saturdaysRemaining = saturdaysCalculatedAsHoliday ? item.saturdaysTotal - item.saturdaysUsed : 0

						return (
							<tr key={item.id}>
								<td style={styles.td}>{item.annualVacationYear}</td>

								<td style={styles.td}>
									{remaining} / {total}
								</td>

								{saturdaysCalculatedAsHoliday && (
									<td style={styles.td}>
										{saturdaysRemaining} / {item.saturdaysTotal}
									</td>
								)}
							</tr>
						)
					})}
				</tbody>
			</table>
		</div>
	)
}

const styles = {
	container: {
		maxWidth: '500px',
		padding: '4px 8px',
		background: 'var(--heeros-purple)',
		color: 'var(--heeros-purple-100)',
		borderRadius: '16px',
	},
	table: {
		width: '100%',
	},
	th: {
		fontWeight: 600,
	},
}
